import React from "react";
import { Box, Typography, Button } from "@mui/material";

const SessionConflictModal = ({ open, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <React.Fragment>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 100,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#1a1a1a",
            padding: 3,
            borderRadius: 2,
            width: 400,
            textAlign: "center",
            color: "#fff",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Already Logged In
          </Typography>
          <Typography variant="body2" gutterBottom>
            You are already logged in on another device. Do you want to log out
            from other devices and continue?
          </Typography>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-around" }}>
            <Button
              fullWidth
              onClick={onConfirm}
              variant="contained"
              sx={{
                bgcolor: "#FFC107",
                color: "#0E0F11",
                mx: 1,
                "&:hover": { bgcolor: "#e6c300" },
              }}
            >
              Yes
            </Button>
            <Button
              fullWidth
              onClick={onCancel}
              variant="outlined"
              sx={{
                color: "#fff",
                borderColor: "#fff",
                mx: 1,
                "&:hover": { borderColor: "#fff" },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default SessionConflictModal;
